<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m10.063 15.698-6.172 3.297 1.229-6.889-5.043-4.85 6.931-.961L10.063 0l3.055 6.295 6.931.96-5.043 4.851 1.229 6.889z"
      fill="#121212"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: { type: Number, default: 20 },
  },
  setup(props) {
    const width = props.size
    const height = props.size * (20 / 19)

    return {
      width,
      height,
    }
  },
})
</script>
